import * as types from '../actions/types';

const initialState = {
  books: [],
  isLoading: false,
  isError: false,
};

export default function booksInfo(state = initialState, action) {
  switch (action.type) {
    case types.GET_BOOK_INFO_REQUEST_START:
      return {
        ...state,
        isLoading: true,
        isError: false,
      };
    case types.GET_BOOK_INFO_REQUEST_COMPLETED:
      return {
        ...state,
        books: action.data,
        isLoading: false,
        isError: false,
      };
    case types.GET_BOOK_INFO_REQUEST_FAILED:
      return {
        ...state,
        isLoading: false,
        isError: true,
      };
    default:
      return state;
  }
}
